import styled from 'styled-components';

export const OutdoorSportsHeaderText = styled.div`
    display: flex;
    align-items: center;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #555555;
    text-transform: uppercase;
    width: auto;
`;

export const OutdoorSportsWithDisneySectionWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    padding: 3%;
    height: 53px;
    background-color: #ffffff;
    border-bottom: 1px solid #EEEEEE;
    align-items: center;
`;

export const DisneyLogoWrapper = styled.a`
    display: flex;
    flex-direction: row;
    width: auto;
    align-items: center;
`;

export const DisneyLogoImg = styled.img`
    width: 137px;
    height: 33px;
`;

export const DisneyPartnershipContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #F9F9F9;
    height: auto;
    width: 100%;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    color: #555555;
    margin: 10px 10px 0 0;
    text-align: center;
`;